<template>
    <div>
        <card>
            <h1 style="color:#00467f;margin-top:15px;text-align:left"><strong>Corsi di formazione</strong></h1>
            <div class="row">
                <div class="col">
                    <button class="btn float-left" type="button" style="background:#00467f" v-on:click="showCreaCorsoFunction()">CREA CORSO</button>
                </div>
            </div>
            <!-- <div class="row" style="margin-top:10px">
                <div style="margin-left:80px;font-weight:bold">
                    <label>Numero di righe per pagina:</label>
                    <select v-model="n_righe" v-on:change="caricaPagina()" style="border: 2.5px solid;border-radius:0.25em;border-color:#00467f;background-color: #fff;width:100%;max-width: 100px;margin-left:30px">
                        <option disabled value="">Please select one</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div class="row justify-content-center" style="margin-bottom:30px;margin-top:20px">
              <div class="col-4">
                <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
              <div class="col-4">
                <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
              </div>
              <div class="col-4">
                <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
            </div> -->
            
            <div v-if="showCreaCorso">
                <div class="row">
                    <div class="col-5">
                        <label for="codice_fiscale"><strong>NOME CORSO</strong></label>
                        <select v-model="nome_corso" class="form-control">
                            <option disabled value="">Seleziona un corso</option>
                            <option>Corso 1</option><!-- v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value" -->
                            <option>Corso 2</option>
                        </select>
                    </div>
                    <div class="col-5">
                        <label for="codice_fiscale"><strong>AULA</strong></label>
                        <select v-model="aula_corso" class="form-control">
                            <option disabled value="">Seleziona un corso</option>
                            <option>Aula 1</option><!-- v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value" -->
                            <option>Aula 2</option>
                        </select>
                    </div>
                    <div class="form-group col-md-2">
                        <!-- <button class="btn" type="button" style="background:#00467f;margin-top:20px"></button> -->
                        <i class="fas fa-plus-circle" style="font-size:35px;margin-top:20px;color:#00467f" v-on:click="creaCorso()"></i>
                    </div>
                </div>
                <div class="row" v-if="corsi.length > 0" style="margin-top:30px">
                        <table class="table tablesorter" id="tabella" style="text-align:center">
                            <thead>
                                <tr>
                                    <th>MODULI</th>
                                    <th>DATA E ORA INIZIO</th>
                                    <th>DATA E ORA FINE</th>
                                    <th>N. ORE</th>
                                    <th>AULA</th>
                                    <th>N. MINIMO PARTECIPANTI</th>
                                    <th>N. MASSIMO PARTECIPANTI</th>
                                    <th>N. PARTECIPANTI ONLINE</th>
                                    <!-- <th></th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="row-color" v-for="(valori, index) in corsi" v-bind:key="index"><!--    -->
                                    <td v-on:click="modificaCorso(index)">{{valori.NOME_MODULO}}</td>
                                    <td>{{getDate(valori.DATETIME_INIZIO)}} {{getTime(valori.DATETIME_INIZIO)}}</td>
                                    <td>{{getDate(valori.DATETIME_FINE)}} {{getTime(valori.DATETIME_FINE)}}</td>
                                    <td>{{valori.N_ORE}}</td>
                                    <td>{{valori.AULA}} </td>
                                    <td>{{valori.N_MIN_PARTECIPANTI}}</td>
                                    <td>{{valori.N_MAX_PARTECIPANTI}}</td>
                                    <td>{{valori.N_PARTECIPANTI_ONLINE}} </td>
                                    <!-- <td>
                                        <div class="form-group col-md-2">
                                            <i class="fas fa-plus-circle" style="font-size:35px;margin-top:20px;color:#00467f" v-on:click="addCorso()"></i>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                <div v-if="showTable" style="margin-top:30px">
                    <div class="form-row">
                        <div class="form-group col-4">
                            <label><strong>NOME MODULO</strong></label>
                            <input type="text" class="form-control" v-model="nome_modulo">
                        </div>
                        <div class="form-group col-4">
                            <label><strong>DATA E ORA INIZIO</strong></label>
                            <input type="datetime-local" class="form-control" v-model="datetime_inizio">
                        </div>
                        <div class="form-group col-4">
                            <label><strong>DATA E ORA FINE</strong></label>
                            <input type="datetime-local" class="form-control" v-model="datetime_fine">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-4">
                            <label><strong>NUMERO DI ORE</strong></label>
                            <input type="number" class="form-control" v-model="n_ore">
                        </div>
                        <div class="form-group col-4">
                            <label><strong>AULA</strong></label>
                            <select v-model="aula" class="form-control">
                                <option disabled value="">Seleziona un corso</option>
                                <option>Aula 1</option><!-- v-for="(val, index) in listaProvince" v-bind:key="index" :value="val.value" -->
                                <option>Aula 2</option>
                            </select>
                        </div>
                        <div class="form-group col-4">
                            <label><strong>NUMERO PARTECIPANTI MINIMO</strong></label>
                            <input type="number" class="form-control" v-model="n_min_partecipanti">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-5">
                            <label><strong>NUMERO PARTECIPANTI MASSIMO</strong></label>
                            <input type="number" class="form-control" v-model="n_max_partecipanti">
                        </div>
                        <div class="form-group col-5">
                            <label><strong>NUMERO PARTECIPANTI ONLINE</strong></label>
                            <input type="number" class="form-control" v-model="n_partecipanti_online">
                        </div>
                        <div class="form-group col-md-2">
                            <i class="fas fa-plus-circle" style="font-size:35px;margin-top:20px;color:#00467f" v-on:click="addCorso()"></i>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <button v-on:click="updateCorso(i)" class="btn float-left" type="button" style="background:#00467f">UPDATE CORSO</button>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import CorsoServices from '@/services/CorsoServices';
import Modal from "@/components/Modal.vue"; //per la lente ricerca
import moment from 'moment';
import VueAwesomeProgress from "vue-awesome-progress";
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';

export default {
    components: {
      Card, Modal, VueAwesomeProgress, VueCustomTooltip
    },
  
    data() {
        return {
            showCreaCorso: false,
            showTable: false,
            nome_corso: null,
            aula_corso: null,
            nome_modulo: null, 
            datetime_inizio: null, 
            datetime_fine: null,
            datetime_fine: null,
            n_ore: null, 
            aula: null, 
            n_min_partecipanti: null,
            n_max_partecipanti: null,
            n_partecipanti_online: null,
            i: null,

            val1: 50,
            color: '#FF0000',
            // searchModalVisible: false,
            // cerca_selezionato: 'codice_corso',
            corsi: [
                {NOME_MODULO: 'MODULO 1', DATETIME_INIZIO: '2022-05-04T22:50', DATETIME_FINE: '2022-06-24T22:50', N_ORE: 10, AULA: 'Aula 1', N_MIN_PARTECIPANTI: 3, N_MAX_PARTECIPANTI: 100, N_PARTECIPANTI_ONLINE: 500},
                {NOME_MODULO: 'MODULO 2', DATETIME_INIZIO: '2022-05-24T22:50', DATETIME_FINE: '2022-07-24T22:50', N_ORE: 20, AULA: 'Aula 2', N_MIN_PARTECIPANTI: 10, N_MAX_PARTECIPANTI: 200, N_PARTECIPANTI_ONLINE: 500}
            ],
            allCorsi: [],
            // n_righe: 15,
            // dataScadenza: null,
            // dateCorsoFrom: null,
            // dateCorsoTo: null,
            access_token: null,
            // filtroScelto: 'dataScadenza',
            // cerca_docente: null,
            // filtra_codice_corso: null,
            // page: 1,
            // totPage: null,
            token_response: [],
            user_livello: null,

            currentSort:'DATA_CORSO',
            currentSortDir:'desc',
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'
        }
    },
    methods: {
        addCorso: function() {
            if (this.checkDati()) {
                this.corsi.push({NOME_MODULO: this.nome_modulo, DATETIME_INIZIO: this.datetime_inizio, DATETIME_FINE: this.datetime_fine, N_ORE: this.n_ore, AULA: this.aula, N_MIN_PARTECIPANTI: this.n_min_partecipanti, N_MAX_PARTECIPANTI: this.n_max_partecipanti, N_PARTECIPANTI_ONLINE: this.n_partecipanti_online});
            
                this.nome_modulo = null;
                this.datetime_inizio = null;
                this.datetime_fine = null;
                this.n_ore = null;
                this.aula = null;
                this.n_min_partecipanti = null;
                this.n_max_partecipanti = null;
                this.n_partecipanti_online = null;
                console.log(this.corsi);
            } else {
                alert("Compilare tutti i dati!");
            }
            
        
        },
        // per prendere tutti i corsi
        caricaCorsi: async function() {
            let errore = 0;
            await CorsoServices.getCorsi()
            .then(response => { this.allCorsi = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.caricaCorsi(); }
            }
            console.log("tutti i corsi: ");
            console.log(this.allCorsi);
        },

        caricaPagina: async function(){
            let risposta;
            let errore = 0;
            await CorsoServices.changePage(1, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                    console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.caricaPagina(); }
            }
            this.corsi = risposta.rows;
            // Faciamo che ne mostro 15 per pagina
            var total = this.allCorsi.length;
            this.totPage = Math.ceil(total/this.n_righe);
        },

        changePage: async function(val){
            let risposta;
            let errore = 0;
            if(val == 'avanti'){
                this.page = this.page + 1;
            } else {
                //indietro
                this.page = this.page - 1;
            }
            await CorsoServices.changePage(this.page, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.changePage(val); }
            }
            this.corsi = risposta.rows;
        },

        checkDati: function() {
            if ( this.nome_modulo == null || this.datetime_inizio == null ||  this.datetime_fine == null || this.n_ore == null || this.aula == null 
                || this.n_min_partecipanti == null || this.n_max_partecipanti == null || this.n_partecipanti_online == null) {
                    return false;
            } else {
                return true;
            }
        },

         getDate(datetime) {
            return moment(String(datetime)).format('DD/MM/YYYY');
        },

        getDateAnnoMeseGiorno(datetime) {
            return moment(String(datetime)).format('YYYY-MM-DD');
        },

        getTime(datetime){
            const myArray = datetime.split("-");
            const arr =  myArray[myArray.length-1].split(":");
            const ora= arr[0].substring(3,5);
            const min = arr[1];
            const time = ora + ":" + min;
            return time;
        },

        modificaCorso: function(index) {
            this.i = index;
            console.log(this.showTable)
            if (!this.showTable) {
                this.showTable = true;
            }

            this.nome_modulo = this.corsi[index].NOME_MODULO;
            this.datetime_inizio = this.corsi[index].DATETIME_INIZIO;
            this.datetime_fine = this.corsi[index].DATETIME_FINE;
            this.n_ore = this.corsi[index].N_ORE;
            this.aula = this.corsi[index].AULA;
            this.n_min_partecipanti = this.corsi[index].N_MIN_PARTECIPANTI;
            this.n_max_partecipanti = this.corsi[index].N_MAX_PARTECIPANTI;
            this.n_partecipanti_online = this.corsi[index].N_PARTECIPANTI_ONLINE;
            
            // this.corsi.push({NOME_MODULO: this.nome_modulo, DATETIME_INIZIO: this.datetime_inizio, DATETIME_FINE: this.datetime_fine, N_ORE: this.n_ore, AULA: this.aula, N_MIN_PARTECIPANTI: this.n_min_partecipanti, N_MAX_PARTECIPANTI: this.n_max_partecipanti, N_PARTECIPANTI_ONLINE: this.n_partecipanti_online});
        },
        updateCorso: function(index) {
            this.corsi[index].NOME_MODULO = this.nome_modulo ;
            this.corsi[index].DATETIME_INIZIO = this.datetime_inizio;
            this.corsi[index].DATETIME_FINE = this.datetime_fine;
            this.corsi[index].N_ORE = this.n_ore;
            this.corsi[index].AULA = this.aula;
            this.corsi[index].N_MIN_PARTECIPANTI = this.n_min_partecipanti;
            this.corsi[index].N_MAX_PARTECIPANTI = this.n_max_partecipanti;
            this.corsi[index].N_PARTECIPANTI_ONLINE = this.n_partecipanti_online;
        },

        showCreaCorsoFunction: function() {
            this.showCreaCorso = true;
        },

        creaCorso: function() {
            this.showTable = true;
        },
        
        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            axios.defaults.withCredentials = true;
            this.access_token = localStorage.getItem('access_token');
            
        }
    },

    mounted() {
        this.main();
    },
    computed:{
    }
  };
</script>
<style scoped>
    td[id^="container"] {
        margin: 30px;
        width: 10px;
        height: 10px;
    }

</style>
  